import React, { FC } from 'react';
import boostIcon from './boost-icon.svg';
import degenerateIcon from './degenerate-icon.svg';
import inactiveIcon from './archive-icon.svg';

import styles from './VaultTag.module.scss';

interface Props {
  type: 'boostable' | 'degenerate' | 'inactive';
}

const getIcon = (type: Props['type']) => {
  switch (type) {
    case 'boostable':
      return boostIcon;
    case 'degenerate':
      return degenerateIcon;
    case 'inactive':
      return inactiveIcon;
    default:
      return boostIcon;
  }
};

const getClassName = (type: Props['type']) => {
  switch (type) {
    case 'boostable':
      return styles.boostableTag;
    case 'degenerate':
      return styles.degenerateTag;
    case 'inactive':
      return styles.inactiveTag;
    default:
      return '';
  }
};

const getIconClassName = (type: Props['type']) => {
  switch (type) {
    case 'boostable':
      return styles.boostableIcon;
    case 'degenerate':
      return styles.degenerateIcon;
    case 'inactive':
      return styles.inactiveIcon;
    default:
      return '';
  }
};

const VaultTag: FC<Props> = ({ type }) => (
  <div className={`${styles.tag} ${getClassName(type)}`}>
    <img className={`${styles.icon} ${getIconClassName(type)}`} src={getIcon(type)} alt="" />

    {type === 'boostable' ? 'Boostable' : ''}
    {type === 'degenerate' ? 'Degenerate' : ''}
    {type === 'inactive' ? 'Inactive' : ''}
  </div>
);

export default VaultTag;
